import { createAppSlice } from 'app-components/utils/redux-store/createAppSlice';

import { fetchWellnessScore } from './wellnessScoreThunks';
import { WELLNESS_SCORE_REDUCER_KEY, type WellnessScoreStoreState } from './wellnessScoreTypes';

const initialState: WellnessScoreStoreState = {
  score: null,
  isLoading: false,
  error: null,
  lastUpdatedAt: null,
  requestId: null,
};

export const wellnessScoreSlice = createAppSlice({
  name: WELLNESS_SCORE_REDUCER_KEY,
  initialState,
  reducers: {
    resetWellnessScore: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWellnessScore.pending, (state, action) => {
      // Keep the previous score while refreshing so the UI does not flash empty.
      state.isLoading = true;
      state.error = null;
      state.requestId = action.meta.requestId;
    });
    builder.addCase(fetchWellnessScore.fulfilled, (state, action) => {
      if (action.meta.requestId !== state.requestId) return;
      state.score = action.payload;
      state.isLoading = false;
      state.lastUpdatedAt = action.meta.fetchedAt;
      state.requestId = null;
    });
    builder.addCase(fetchWellnessScore.rejected, (state, action) => {
      if (action.meta.requestId !== state.requestId) return;
      state.isLoading = false;
      state.error = action.meta.aborted
        ? null
        : (action.payload ?? { kind: 'unknown', message: action.error.message ?? 'Failed to fetch wellness score' });
      state.requestId = null;
    });
  },
});

export const wellnessScoreActions = wellnessScoreSlice.actions;
export default wellnessScoreSlice;
